import { LanguageMode } from "./language-modes";

export interface PendingCodeReviewComment {
	id: string;
	lineStart: number;
	lineStop: number;
	reviewText: string;
}

export interface CodeReviewComment {
	commentId: string;
	// author of comment
	authorName: string;
	// comment info
	lineStart: number;
	lineStop: number;
	reviewText: string;
	// Date and time
	dateTime: Date; // DD-MM-YY hh:mm AM|PM
}

export interface CodeReviewComments {
	comments: CodeReviewComment;
	snippetId: string;
}

export interface CodeSnippet {
	isAuthor: boolean;
	hasBeenReviewed: boolean;
	snippetId: string;
	authorName: string;
	title: string;
	languageMode: string;
	codeText: string;
	// Revision
	revision: number; // revision number
	latestRevision: number; // latest Revision.
	dateTime: Date; // DD-MM-YY hh:mm AM|PM
}

export interface CRCommentNotification {
	notificationId: string;
	notificationType: string;
	snippetId: string; // CodeReviewPost that this notification is tied to
	revision: number;
	snippetTitle: string; // title of the notification
	description: string;
	dateTime: Date;
	activityCreatedDateTime: Date;
}

export const CreateDefaultPendingComment = (): PendingCodeReviewComment => {
	return {
		lineStop: 1,
		lineStart: 1,
		reviewText: "",
		id: "",
	};
};
export const CreateDefaultPost = (): CodeSnippet => {
	return {
		isAuthor: false,
		hasBeenReviewed: false,
		snippetId: "",
		authorName: "",
		title: "",
		codeText: "",
		languageMode: LanguageMode.language.python,
		dateTime: new Date(),
		revision: 0,
		latestRevision: 0,
	};
};
